import { render, staticRenderFns } from "./defaultForAffiliates.vue?vue&type=template&id=528e2926"
import script from "./defaultForAffiliates.vue?vue&type=script&lang=js"
export * from "./defaultForAffiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports